/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeflyersstylewhite3Inputs */

const en_placeflyersstylewhite3 = /** @type {(inputs: Placeflyersstylewhite3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`White for home printing`)
};

const de_placeflyersstylewhite3 = /** @type {(inputs: Placeflyersstylewhite3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiß zum Selbstdrucken`)
};

/**
* | output |
* | --- |
* | "White for home printing" |
*
* @param {Placeflyersstylewhite3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placeflyersstylewhite3 = /** @type {((inputs?: Placeflyersstylewhite3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeflyersstylewhite3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeflyersstylewhite3(inputs)
	return de_placeflyersstylewhite3(inputs)
});
export { placeflyersstylewhite3 as "placeFlyersStyleWhite" }